import { captureMessage } from "@sentry/react";
import { OhApi } from "@shared/libs/siayuda";
import { t } from "i18next";

import { formatPrerequisiteData } from "./missing-prerequisite-data";

export const NOT_MAPPED = "Erreur inconnue. Veuillez envoyer un mail à support@groupe.ouihelp.fr";

export const UPGRADE_REQUIRED = "UPGRADE_REQUIRED";

const errorMessages = {
  INVALID: "Champ incorrect",
  REQUIRED: "Veuillez renseigner ce champ",
  PHONE_ALREADY_USE: "Ce numéro de téléphone est déjà attribué à quelqu'un",
  PHONE_REFUSED: "Le numéro de téléphone est incorrect",
  PHONE_INVALID:
    "Le numéro de téléphone est invalide. Veuillez préciser l'indicatif du numéro (Ex: +33). Sinon, vérifiez que le numéro est bien attribué",
  CAREGIVER_ALREADY_HAVE_XIMI_ID: "L'intervenant a déjà un compte Ximi associé",
  XIMI_ID_ALREADY_BOUND_TO_OTHER: "Cet identifiant Ximi est déjà associé à un autre intervenant",
  PROCESSING_ERROR: "Impossible de trouver un visage dans l'image envoyée",
  PROCLIENT_ALREADY_HAVE_REFERENCE_CONTACT: "Ce bénéficiaire a déjà un contact de référence",
  PROCLIENT_IS_ALREADY_GONE: "Ce prospect/bénéficiaire est déjà parti",
  CANNOT_CLEAR_EXISTING_OWNER: "Impossible de retirer le propriétaire d'un prospect déjà attribué",
  CANT_AFFECT_PROSPECT_GONE_REASON_TO_CLIENT:
    "Impossible d'affecter une raison de départ prospect à un client",
  CANT_AFFECT_CLIENT_GONE_REASON_TO_PROSPECT:
    "Impossible d'affecter une raison de départ client à un prospect",
  CAN_NOT_INSERT_OUIHELP_SERVICE_ON_PRESCRIBER:
    "Impossible d'attribuer un service Ouihelp à un prescripteur",
  CAREGIVER_INVALID_SSN: "Ce numéro de sécurité sociale est invalide",
  FORBIDDEN_CHARACTERS: "Votre texte contient des caractères non autorisés",
  MAIL_ALREADY_USE: "Le mail fourni est déjà utilisé",
  DUPLICATE_MAIL_TO_NOTIFY: "Cette adresse email est déjà utilisée comme destinataire",
  PROCLIENT_HAVE_TWO_MEMBERS: "La fiche contient déjà deux membres",
  FILE_TYPE:
    "Le format du fichier importé n'est pas accepté. Veuillez importer un fichier au format PDF.",
  IBAN_BIC_AND_ACCOUNT_OWNER_FULL_NAME_REQUIRED_TOGETHER:
    "Veuillez fournir l'intégralité des données bancaires",
  IBAN_BIC_MISMATCH: "L'IBAN et le BIC ne correspondent pas",
  LETTER_ADDRESS_LINE_TOO_LONG:
    "L'adresse principale dépasse la limite de 45 caractères, veuillez la raccourcir. Vous pouvez utiliser le complément d'adresse si besoin.",
  CESU_PAYMENT_WITHOUT_CESU_SETTINGS:
    "Ce bénéficiaire n’a pas CESU comme mode de règlement principal." +
    " Éditez les modalités de facturation du bénéficiaire pour ajouter de nouveaux règlements par CESU.",
  CLOSED_CALL_EVALUATION_CAN_NOT_BE_UPDATED: "Cette interface d'appel est fermée",
  // ------ CALL EVALUATION ------ //
  CANNOT_DEBRIEF_EVENT_RELATED_TO_CALL_EVALUATION:
    "Impossible de débriefer un directement évènement lié à une interface de programmation de VEB." +
    " Veuillez modifier l'interface de programmation de VEB directement.",
  CANNOT_DELETE_EVENT_RELATED_TO_CALL_EVALUATION:
    "Impossible de supprimer un directement évènement lié à une interface de programmation de VEB." +
    " Veuillez modifier l'interface de programmation de VEB directement.",
  ONGOING_CALL_EVALUATION_ALREADY_EXISTS_FOR_PROCLIENT:
    "Une instance d'appel existe déjà pour ce prospect",
  CAN_NOT_CREATE_CALL_EVALUATION_FOR_STAGE:
    "Il est impossible d'ouvrir une interface d'appel pour ce statut de prospect",
  CAN_NOT_CREATE_FOR_COUPLE: "Cette action est impossible pour les couples.",
  NO_ACTIVE_MEMBER: "Aucun bénéficiaire actif rattaché à cette fiche.",
  EXISTING_PROCLIENT_NOT_FOUND: "Le prospect n'existe pas",
  UNCOMPLETED_CALL_EVALUATION_ALREADY_EXISTS:
    "Une interface de programmation de VEB est déjà en cours pour ce prospect",
  COMPLETED_CALL_EVALUATION_SHOULD_SCHEDULE_VISIT: "Merci de planifier une VEB.",
  NOT_VALID_ATTENDEES_COUNT:
    "Le nombre de participants sélectionnés dépasse le nombre de contacts disponibles",
  NOT_VALID_ATTENDEE_CONTACT_INDEX:
    "Les données du contact participant sont obsolètes, veuillez rafraîchir la page et réessayer",
  NO_ATTENDEE_SELECTED: "Veuillez sélectionner au moins un participant pour la visite",
  VISIT_PLACE_NAME_OR_ADDRESS_MISSING:
    "Veuillez renseigner le nom et l'adresse du lieu de la visite",
  PROCLIENT_PLACE_MISSING: "Veuillez renseigner l'adresse du bénéficiaire",
  CANNOT_OVERRIDE_EXISTING_CALL_EVALUATION_EVENT:
    "Un évènement a déjà été rattaché à cette interface d'appel",
  // ------ END CALL EVALUATION ------ //
  CANCELLATION_REASON_REQUIRED: "Veuillez fournir une raison d'annulation",
  CANCELLATION_REASON_MORE_REQUIRED:
    "Veuillez fournir plus d'informations sur la raison d'annulation",
  UNKNOWN_USER: "Ce compte utilisateur n'existe pas",
  DELETED_USER: "Ce compte utilisateur a été supprimé",
  COLLABORATOR_NOT_INSIDE_SALES: "Ce collaborateur n'est pas un Inside Sales",
  VEB_EVALUATION_LOCKED:
    "Une opération sur la VEB est en cours, veuillez réssayez dans quelques instants.",
  LOGIN_ERROR: "Erreur de connexion inconnue",
  PDF_IS_CORRUPTED:
    "Le fichier que vous essayez d'ouvrir semble être corrompu et ne peut pas être utilisé",
  PRICE_TOO_SMALL: "Le prix est trop bas",
  PRICE_TOO_EXPENSIVE: "Le prix est trop élevé",
  PRICE_MISMATCH: "Le prix est différent de celui attendu",
  WRONG_VALUE: "La valeur est incorrecte",
  PROCLIENT_INVALID_STAGE: "Le bénéficiaire n'est plus dans le bon statut",
  COMPLETED_VEB_EVALUATION_CAN_NOT_BE_UPDATED: "La VEB ne peut plus être mise à jour",
  CANNOT_UPDATE_CARTS_IF_QUOTE_DOCUMENT_ALREADY_EXISTS:
    "Supprimez d'abord le devis pour mettre à jour l'accompagnement",
  CANNOT_UPDATE_MONET_SETTINGS_DATA_IF_SEPA_WARRANT_DOCUMENT_ALREADY_EXISTS:
    "Un mandat SEPA existe déjà",
  CAN_NOT_DEBRIEF_EVENT: "La visite a déjà été débriefée ou n'existe plus",
  PAYMENT_SETTING_ALREADY_SET_FOR_PROCLIENT_MEMBER:
    "Les paramètres de paiement sont déjà renseignés",
  PROSPECT_TYPE_UPDATE_NOT_ALLOWED: "Impossible de mettre à jour le type de prospect",
  URSSAF_REJECTION_ERROR: "Erreur lors de la validation URSSAF",
  CANNOT_SEND_ANOTHER_VALIDATION_MAIL_YET: "Impossible d'envoyer un autre mail de validation",
  WRONG_PROCLIENT_TYPE: "Mauvais type de bénéficiaire",
  COLLABORATOR_NOT_FOUND: "Le collaborateur n'existe pas.",
  COLLABORATOR_IS_NOT_OPS: "Le collaborateur ne travaille pas en agence",
  EXISTING_BLACKLIST_COUPLE: `Le couple ${t("caregiver_short")}/BNF est déjà non recommandé`,
  COLLABORATOR_IS_NOT_BUSINESS_DEVELOPER: "Le collaborateur n'est pas business developer",
  IN_ENVELOPE_DOCUMENT_IS_READ_ONLY:
    "Les documents présents dans une enveloppe ne peuvent pas être modifiés",
  INVALID_PROSPECT_TYPE_CHANGE: "Le changement de type du prospect est incorrect",
  NO_EXTRA_FIELD: "Une erreur est survenue, si cela persiste, merci de contacter la tech",
  PROCLIENT_WITHOUT_ZONE: "Le bénéficiaire n'est associé à aucune zone.",
  URSSAF_ACCOUNT_ALREADY_EXISTS: "Un compte URSSAF existe déjà pour ce bénéficiaire",
  URSSAF_ACCOUNT_NOT_INITIAL: "La demande URSSAF AICI n'est plus en statut initial",
  URSSAF_ACCOUNT_RECENTLY_UPDATED: "Une demande a déjà été envoyée il y a moins de 5 minutes",
  MUST_BE_EXACTLY_ONE_ISSUE_FOR_CLOSING: "Il doit y avoir exactement un incident pour clôturer.",
  INTERVENTION_ALREADY_ASSIGNED: "L'intervention a déjà été assignée.",
  MISSING_PROCLIENT_XIMI_DATA: "Les données Ximi pour le bénéficiaire sont manquantes.",
  INTERVENTION_DOES_NOT_EXIST: "L'intervention demandée n'existe pas.",
  INTERVENTION_NOT_VACANT: "L'intervention n'est pas à pourvoir.",
  INTERVENTION_TO_STAFF_NOT_FOUND: "L'intervention à pourvoir n'a pas été trouvée.",
  FUTURE_VEB: "La VEB n'est pas encore annulable.",
  CITY_NOT_FOUND: "La ville de l'adresse du bénéficiaire n'existe pas dans DSIT",
  LEGAL_ENTITY_MODE_NOT_SUPPORTED:
    "Cette fonctionnalité n'est pas accessible pour le mode prestataire.",
  ALREADY_ONGOING_BILL_FOR_MONTH:
    "Il existe déjà une facture non envoyée pour ce bénéficiaire et cette période.",
  XIMI_REGISTRATION_FAILED: "La création du profil Ximi a échoué.",
  ENTITY_ORIGIN_BINDING_ALREADY_EXISTS_FOR_TARGET_SOURCE:
    "Une personne ne peut pas être à la fois en origine et en remontée de filière d’une autre personne, modifier l’origine afin de poursuivre.",
  ENTITY_NOT_FOUND_FOR_ENTITY_TYPE: "La personne à l'origine n'a pas été trouvée.",
  CANNOT_HAVE_MORE_THAN_ONE_FAVORITE_PRODUCT:
    "Vous ne pouvez pas avoir plus d'un accompagnement favori.",
  CANT_ASSIGN_A_RESOLVED_INTERVENTION: "Cette intervention a déjà été résolue",
  CANNOT_MARK_AS_GONE_LAST_MEMBER_OF_COUPLE:
    "Impossible de passer en inactif tous les membres d'un couple en même temps. Passer la fiche en parti si besoin",
  PROCLIENT_HAVE_NO_PLACE_JSON: "Veuillez renseigner l'adresse du bénéficiaire",
  // ---------- events ----------
  CANNOT_CANCEL_DEBRIEFED_EVENT:
    "Impossible d'annuler un évènement déjà débriefé, veuillez rafraichir la page",
  EVENT_ALREADY_DEBRIEFED: "Cet évènement a déjà été débriefé",
  CANNOT_UPDATE_EVENT_WHEN_EVENT_SCHEDULED:
    "Impossible de modifier un évènement lorsqu'il est déjà planifié",
  CANNOT_SCHEDULE_EVENT_IN_PAST:
    "Impossible de planifier un évènement dans le passé. Veuillez vérifier les dates et réessayer.",
  ISSUE_WITH_NOTIFICATION: "Erreur lors de l'envoi de la notification",
  // ---------- Documents signables ----------
  DOCUMENTS_DOES_NOT_MEET_SPECIFICATIONS_TO_BE_SIGNED:
    "Les documents sélectionnés ne remplissent pas les conditions nécessaires.",
  CANNOT_GENERATE_DOCUMENT_FOR_COUPLES: "Impossible de générer un document pour un couple",
  SIGNATORY_NOT_FOUND: "Signataire inconnu",
  UNKNOWN_OUIHELP_REPRESENTATIVE: "Représentant de ouihelp inconnu. Vérifiez l'email associé.",
  DOCUMENTS_NOT_FOUND: "Documents associés inconnu. Vérifier qu’ils sont bien générés sur Hassibot",
  REPRESENTATIVE_NOT_KNOWN_BY_DOCUSIGN:
    "Aucun compte Docusign associé à ce représentant Ouihelp. Merci de créer le compte associé, si il vient d'être crée, il sera actif sur Hassibot d'ici 1h.",
  MONET_BANK_ACCOUNT_ALREADY_USED: "Le compte bancaire actuel est déjà associé à un mandat SEPA",
  GENERATE_DISABLED_FOR_COUPLE: "La génération de document n'est pas gérée pour les couples",
  BANK_ACCOUNT_ALREADY_BOUND_TO_DOCUMENT:
    "La section \"Mandat SEPA\" contient déjà un document : s'il s'agit effectivement d'un mandat SEPA, inutile d'en générer un deuxième.\nS'il s'agit d'une erreur, veuillez déplacer le document existant dans la section \"Autres documents\", puis générer ou ajouter le mandat SEPA",
  MISSING_LEGAL_INFORMATION_FOR_SEPA_WARRANT:
    "La génération du mandat SEPA est bloquée temporairement car des informations juridiques sont manquantes. Nous vous informerons dès que la génération sera accessible.",
  DELEGATE_CANT_BE_REPRESENTATIVE:
    "Le référent ne peut pas signer sa propre délégation de pouvoir (le bénéficiaire et le référent doivent être deux personnes distinctes)",
  CANNOT_SEND_TO_XIMI_FOR_COUPLES: "Impossible d'envoyer un document sur Ximi pour un couple",
  CANNOT_UPDATE_ORIGIN_ENTITY_FOR_HUBSPOT_PROCLIENT:
    "Impossible de modifier le prescripteur à l'origine d'un bénéficiaire Hubspot",
  COLLABORATOR_NOT_KNOWN_BY_DOCUSIGN: "Vous n'avez pas de compte DocuSign",
  NOT_A_QUOTATION_DOCUMENT: "Ce document n'est pas un devis",
  ALREADY_SENT_XIMI_QUOTE_DOCUMENT: "Ce document a déjà été envoyé sur Ximi",
  QUOTE_XIMI_DISABLED_FOR_CONTRACTOR:
    "L'envoi du devis sur Ximi n'est disponible qu'en mode mandataire.",
  MISSING_GEOLOCATION_DATA:
    "Les données de géolocalisation sont manquantes. Veuillez activer la géolocalisation pour continuer.",
  MISSING_CONTRACTOR_BANK_DATA:
    "Des informations bancaires du bénéficiaire sont manquantes (IBAN, BIC ou RUM). Vous pouvez les compléter sur ximi. " +
    "Une fois celles-ci ajoutées, vous pourrez générer le mandat SEPA (la synchronisation peut prendre une dizaine de minutes).",
  DOCUMENT_IN_VALIDATED_ASSERTION_IS_READ_ONLY:
    "Le document validé ne peut pas être modifié ou supprimé",
  PROCLIENT_AGENCY_REQUIRED:
    "L'agence du bénéficiaire est requise pour générer ce document. Veuillez la renseigner avant de réessayer.",

  // ---------- onkol -----------
  INVALID_AGENCY_UUIDS: "Il y a un problème avec la liste de vos agences. Veuillez envoyer un mail à support@groupe.ouihelp.fr",

  // ---------- planning ----------
  PLAN_DURATION_TOO_LONG: "La durée de ce plan dépasse la plage horaire saisie",
  DATE_TO_MUCH_IN_THE_FUTURE:
    "Vous ne pouvez pas rechercher avec une date de début au delà de 4 semaines.",

  // ---------- shared house splitting run errors ----------
  ALREADY_ONGOING_SYNCHRONIZATION_FOR_SHARED_HOUSE:
    "Une synchronisation est déjà en cours pour cette maison partagée à cette période.",
  INVALID_SPLITTING_RUN_STATUS_FOR_SYNCHRONIZATION:
    "Impossible de lancer la synchronisation pour cette période (un petit mot à la tech plz).",
  SHARED_HOUSE_SPLITTING_RUN_SYNCHRO_ERROR:
    "Des erreurs sont intervenues lors de la dernière tentative de synchronisation. Veuillez essayer de la relancer.",

  // ---------- chat ----------
  CANT_HAVE_MULTIPLE_CHAT_GROUPS_FOR_SAME_PROCLIENT:
    "Impossible d'avoir plusieurs groupes de discussion pour le même bénéficiaire",
  NO_INTERVENTION_BETWEEN_CAREGIVER_AND_PROCLIENT:
    "Aucune intervention n'existe entre cet intervenant et ce bénéficiaire, il n'est pas possible de créer un groupe de discussion pour ces personnes",
  NO_CONTRACT_BETWEEN_CAREGIVER_AND_PROCLIENT:
    "Aucun contrat n'existe entre cet intervenant et ce bénéficiaire, il n'est pas possible de créer un groupe de discussion pour ces personnes",
  PROCLIENT_DOES_NOT_HAVE_AN_AGENCY:
    "Le bénéficiaire n'est associé à aucune agence, il n'est pas possible de créer un groupe de discussion pour ce bénéficiaire",
  NO_GROUP_CHAT_TO_EDIT:
    "Le groupe de discussion n'existe pas ou a été archivé, il n'est pas possible de le modifier",

  // ---------- AI / LLM ----------
  LLM_ERROR: "Une erreur est survenue lors du traitement par l'IA. Veuillez réessayer.",

  // ---------- monet bill batch actions ----------
  INVALID_BILL_TYPE_FOR_BATCH_ACTION:
    "Les sous-factures reste à charge et tiers-payeur ne peuvent pas être traitées séparément. Veuillez rafraîchir la page et vérifier votre sélection.",
  LOCKED_BILL_FOR_BATCH_ACTION:
    "Impossible d'effectuer cette action groupée sur des factures déjà envoyées. Veuillez rafraîchir la page et vérifier votre sélection.",
  UNLOCKED_BILL_FOR_BATCH_ACTION:
    "Impossible d'effectuer cette action groupée sur des factures non envoyées. Veuillez vérifier votre sélection.",
  NO_BILLS_FOUND_FOR_BATCH_ACTION:
    "Aucune facture trouvée pour cette action groupée. Veuillez rafraîchir la page et vérifier votre sélection.",
  BILLS_ALREADY_IN_DESIRED_STATUS:
    "Les factures sont déjà dans le statut souhaité. Veuillez rafraîchir la page et vérifier votre sélection.",
  BILLS_MUST_HAVE_SAME_STATUS_TO_BATCH_UPDATE:
    "Toutes les factures doivent avoir le même statut initial pour effectuer cette action groupée. Veuillez rafraîchir la page et vérifier votre sélection.",

  // ---------- monet payment ------------
  BREAKDOWN_IN_PROGRESS:
    "Une proposition de lettrage est en cours, impossible de modifier le paiement durant ce processus",
  ILLEGAL_BREAKDOWN:
    "Le lettrage demandé est invalide pour ce paiement. Veuillez vérifier les factures sélectionnées et réessayer.",

  // ---------- monet third-party coverages ----------
  LEGACY_COVERAGE_WITHOUT_FINANCIAL_HELP_ON_PERIOD:
    "Une prise en charge sans aide financière existe déjà pour ce tiers-payeur sur cette période. Veuillez d'abord la supprimer ou modifier sa période avant d'en créer une nouvelle avec aide financière.",
  COVERAGE_ALREADY_EXISTS:
    "Il existe déjà une prise en charge avec ce tiers-payeur sur cette période.",
  COVERAGE_WITH_OTHER_THIRD_PARTY_PAYER_ON_PERIOD:
    "Il existe déjà une prise en charge avec un autre tiers-payeur sur cette période.",
  THIRD_PARTY_PAYER_NOT_FOUND: "Le tiers-payeur est introuvable.",
  THIRD_PARTY_FINANCIAL_HELP_NOT_FOUND: "L'aide financière est introuvable.",
  MISSING_PRICING_STRATEGIES_TEMPLATE:
    "Aucune grille tarifaire n'est configurée pour cette aide financière. Veuillez en créer une avant d'ajouter des conditions.",
  COVERAGE_HAS_NO_FINANCIAL_HELP:
    "Impossible d'ajouter des conditions à une prise en charge sans aide financière.",
  MISSING_PARTICIPATION_TYPE: "Le type de participation de la prise en charge n'est pas renseigné.",
  UNSUPPORTED_PARTICIPATION_TYPE: "Ce type de participation n'est pas encore géré.",
  CEILING_DETAIL_TYPE_MISMATCH:
    "Impossible de modifier le type de plafond d'une condition existante.",
  UNSUPPORTED_COMMISSIONER_CEILING_DETAIL_TYPE:
    "Ce type de tiers-payeur ne peut avoir qu'un plafond unique.",
  AICI_NOT_ALLOWED_FOR_EXISTING_COVERAGE:
    "Impossible de demander l'AICI lorsque le bénéficiaire a déjà une prise en charge tiers-payeur active.",
  PROCLIENT_MEMBER_HAS_IMMEDIATE_TAX_CREDIT_AFFILIATION:
    "Impossible de créer ou modifier une prise en charge tiers-payeur pour un bénéficiaire ayant une affiliation AICI en cours ou active.",

  // ---------- monet explanation of payment ------------
  MISSING_DOCUMENT_BYTES: "Le fichier PDF est manquant.",
  FAILED_TO_UPLOAD_EXPLANATION_OF_PAYMENT_TO_S3:
    "Une erreur est survenue lors de l'envoi du fichier.",
  PAYMENT_METADATA_NOT_FOUND: "Paiement introuvable.",
  PAYMENT_BREAKDOWN_STATUS_NOT_ALLOWED:
    "Le bordereau ne peut pas être importé pour ce statut de lettrage.",
  EXPLANATION_OF_PAYMENT_EXTRACT_ALREADY_EXISTS:
    "Un bordereau a déjà été importé pour ce paiement.",

  // ---------- monet contractor regularizations ----------
  CONTRACTOR_REGULARIZATION_NOT_FOUND: "La régularisation est introuvable.",
  CONTRACTOR_REGULARIZATION_INVALID_STATUS:
    "Cette régularisation ne peut pas être traitée dans son statut actuel.",
  CONTRACTOR_REGULARIZATION_FINAL_STATUS_REACHED:
    "Cette régularisation a atteint un statut final et ne peut plus être modifiée.",
  CONTRACTOR_REGULARIZATION_TARGET_CHANGE_NOT_ALLOWED:
    "Impossible de modifier la cible de cette régularisation.",
  CONTRACTOR_REGULARIZATION_CATEGORY_CHANGE_NOT_ALLOWED:
    "Impossible de modifier la catégorie de cette régularisation.",
  CONTRACTOR_REGULARIZATION_ITEMS_NOT_UPDATABLE:
    "Les éléments de cette régularisation ne peuvent pas être modifiés dans son statut actuel.",
  CONTRACTOR_REGULARIZATION_PENDING_DEMAND_ALREADY_EXISTS:
    "Une demande de régularisation est déjà en cours pour cette intervention.",
  CONTRACTOR_REGULARIZATION_BILL_ITEM_INVALID_COVERAGE:
    "La prise en charge sélectionnée n'appartient pas à ce bénéficiaire.",
  CONTRACTOR_REGULARIZATION_BILL_ITEM_SAME_COVERAGE:
    "Plusieurs éléments de facture concernent la même prise en charge.",
  CONTRACTOR_REGULARIZATION_INVALID_REGULARIZATION_FOR_ENTITY:
    "Cet élément de régularisation est invalide pour cette entité.",
  CONTRACTOR_REGULARIZATION_NO_BILL_ITEMS_TO_APPLY:
    "Aucun élément de facture à appliquer pour cette demande de régularisation.",
  PROCLIENT_MEMBER_INTERVENTION_MISMATCH:
    "Le bénéficiaire ne correspond pas à l'intervention sélectionnée.",
  CAREGIVER_INTERVENTION_MISMATCH: "L'intervenant ne correspond pas à l'intervention sélectionnée.",

  // ---------- common / entity not found (auto-generated API codes, reused across several endpoints) ----------
  CAREGIVER_NOT_FOUND: "L'intervenant est introuvable.",
  PROCLIENT_MEMBER_NOT_FOUND: "Le bénéficiaire est introuvable.",
  PROCLIENT_MEMBER_HAS_NO_XIMI_DATA: "Le bénéficiaire n'a pas de données Ximi associées.",
  INTERVENTION_NOT_FOUND_BY_XIMI_ID: "L'intervention est introuvable sur Ximi.",
};

const errorMessagesWithExtra = {
  PRICE_TOO_SMALL: ({ min }: { min: number }) =>
    `Le prix doit être supérieur ou égal à ${min / 100}€`,
  PRICE_TOO_EXPENSIVE: ({ max }: { max: number }) =>
    `Le prix doit être inférieur ou égal à ${max / 100}€`,
  PRICE_MISMATCH: ({ value }: { value: number }) => `Le prix doit être égal à ${value / 100}€`,

  // ---------- Documents signables ----------
  MISSING_PREREQUISITE_DATA: (extraError?: string[] | { missingData: string[] }) => {
    return extraError && !Array.isArray(extraError)
      ? formatPrerequisiteData(extraError.missingData).join("\n")
      : "Une information est manquante pour générer le document";
  },
  MISSING_DATA_FOR_SIGNATORY: (extraError?: string[] | { missingData: string[] }) => {
    if (!Array.isArray(extraError)) return "";
    const translateField: Record<string, string> = {
      mail: "Email",
      first_name: "Prénom",
      last_name: "Nom",
    };
    return `${extraError
      .map(k => translateField[k] ?? k)
      .join(
        ", "
      )} du signataire sélectionné manquant. Veuillez renseigner le/les champ.s manquant.s`;
  },
};

/* for more accurate error messages, we consume the extra to build message
 * use this instead of ErrorsMessages for better messages
 */
export const accurateErrorsMessages = {
  ...errorMessages,
  ...errorMessagesWithExtra,
};

export type OhError = keyof typeof accurateErrorsMessages;

export const handleUnknownError = (type: string) => {
  captureMessage("Received unknown error type : " + type);
  return NOT_MAPPED;
};

export const formatError = (
  error: string | undefined,
  extraMessages?: Record<string, string>
): string | undefined => (error ? messageFor(extraMessages)(error) : undefined);

export const messageFor =
  (extraMessages?: Record<string, string>) =>
    (key: string | undefined): string => {
      if (!key) {
        return NOT_MAPPED;
      }
      return extraMessages && key in extraMessages
        ? (extraMessages[key] as string)
        : key in errorMessages
          ? (errorMessages[key] as string)
          : NOT_MAPPED;
    };

export const handleDocumentGlobalError = (resp: OhApi.GlobalError): string[] => {
  const errorMessage = accurateErrorsMessages[resp.error];
  const error =
    typeof errorMessage === "function"
      ? errorMessage(resp.extra as string[] | { missingData: string[] })
      : errorMessage;

  return [error || NOT_MAPPED];
};
